import { render, staticRenderFns } from "./CreatePost.vue?vue&type=template&id=3d1b6b8b&"
import script from "./CreatePost.vue?vue&type=script&lang=js&"
export * from "./CreatePost.vue?vue&type=script&lang=js&"
import style0 from "./CreatePost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports